if (!customElements.get("sticky-scroller")) {
  class StickyScroller extends HTMLElement {
    constructor() {
      super();
      this.headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
        10
      );
      this.parent = this.parentElement;
    }

    connectedCallback() {
      this.newScrollPosition = 0;
      this.oldScrollPositon = 0;
      this.ticking = false;
      this.element = this.querySelector(".sticky-scroller--element");
      this.element.style.overflowY = "hidden";
      this.observer = new ResizeObserver(this.onWindowScroll.bind(this));
      this.observer.observe(this.parent);
      window.addEventListener("scroll", this.onWindowScroll.bind(this), {
        passive: true
      });
    }

    onWindowScroll() {
      this.newScrollPosition = window.scrollY;
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.translate();
          this.ticking = false;
          this.oldScrollPositon = this.newScrollPosition;
        });
        this.ticking = true;
      }
    }

    translate() {
      const parentRect = this.parentElement.getBoundingClientRect();
      const distance = this.newScrollPosition - this.oldScrollPositon;
      const maxScroll = this.element.scrollHeight - this.element.clientHeight;

      // Not yet in the stuck range: keep the panel pinned to its own top,
      // instead of only skipping the update. Skipping left a stale scrollTop
      // behind once the page got scrolled all the way back up, which is the
      // "doesn't return completely to top" bug.
      if (parentRect.top > this.headerHeight) {
        this.element.scrollTop = 0;
        return;
      }

      // Past the stuck range at the bottom: pin the panel to its own bottom,
      // for the same reason as above.
      if (parentRect.bottom < window.innerHeight) {
        this.element.scrollTop = maxScroll;
        return;
      }

      this.element.scrollTop += distance;
    }
  }

  customElements.define("sticky-scroller", StickyScroller);
}